// "Coming soon" hubs for sports Statlign hasn't launched yet.
//
// These absorb high-intent traffic (tennis, UFC, cricket, horse racing) without
// pretending we already have picks. Every hub is transparent — SEO metadata,
// FAQ, waitlist CTA. Handled by src/pages/SportPreviewLanding.tsx.

export interface SportPreview {
  slug: string;
  sport: string;
  label: string;
  h1: string;
  title: string;
  description: string;
  intro: string;
  keywords: string;
  faqs: { question: string; answer: string }[];
}

export const SPORT_PREVIEWS: SportPreview[] = [
  {
    slug: "tennis-today",
    sport: "Tennis",
    label: "Tennis Predictions",
    h1: "Tennis Predictions Today (Coming Soon)",
    title: "Tennis Predictions Today | Statlign",
    description:
      "Tennis predictions are coming to Statlign. Join the waitlist for AI-driven ATP, WTA and Grand Slam picks with transparent reasoning.",
    intro:
      "We're expanding Statlign's engine into tennis: ATP, WTA and Grand Slam markets. Join the waitlist to be first when tennis picks go live.",
    keywords:
      "tennis predictions today, tennis betting tips, tennis picks today, atp predictions, wta predictions",
    faqs: [
      {
        question: "When will tennis predictions launch on Statlign?",
        answer:
          "We're actively expanding the engine into tennis. Join the waitlist and we'll notify you the day picks go live.",
      },
      {
        question: "Which tours will you cover first?",
        answer:
          "ATP, WTA and Grand Slams (Australian Open, Roland Garros, Wimbledon, US Open) will be the first surfaces we ship.",
      },
    ],
  },
  {
    slug: "cricket-today",
    sport: "Cricket",
    label: "Cricket Predictions",
    h1: "Cricket Predictions Today (Coming Soon)",
    title: "Cricket Predictions & IPL Tips | Statlign",
    description:
      "Cricket predictions are coming to Statlign — IPL, T20, ODI and Test match picks generated by our AI model with clear reasoning.",
    intro:
      "Cricket predictions coming soon: IPL, T20 leagues, ODIs and Tests. Join the waitlist to be first when picks go live.",
    keywords:
      "cricket predictions today, ipl prediction, cricket match prediction, cricket betting tips, cricket tips",
    faqs: [
      {
        question: "Which cricket competitions will you cover?",
        answer:
          "IPL first, then major T20 leagues (BBL, PSL, CPL, The Hundred), ODI internationals and Test matches.",
      },
    ],
  },
  {
    slug: "horse-racing-today",
    sport: "Horse Racing",
    label: "Horse Racing Tips",
    h1: "Horse Racing Tips Today (Coming Soon)",
    title: "Horse Racing Tips Today | Statlign",
    description:
      "Horse racing tips are coming to Statlign — AI-driven picks for major UK, Irish, US and international meetings with transparent model reasoning.",
    intro:
      "Horse racing tips coming soon: UK, Irish, US and international meetings. Join the waitlist to be first when tips go live.",
    keywords:
      "horse racing tips today, horse racing tips tomorrow, free horse racing tips, horse betting tips, racing tips today",
    faqs: [
      {
        question: "Will you cover Grand National and Cheltenham?",
        answer:
          "Yes. Grand National, Cheltenham Festival, Royal Ascot and every major UK/Irish meeting will be first-class surfaces.",
      },
    ],
  },
];

export function findSportPreview(slug: string): SportPreview | undefined {
  return SPORT_PREVIEWS.find((s) => s.slug === slug);
}

export const SPORT_PREVIEW_ROUTES = SPORT_PREVIEWS.map((s) => `/predictions/${s.slug}`);
